// NOT: docs/assets/mqle-pdp.js.md — gerekceler ve KONTRATLAR orada. Degistirmeden once oku.
if (!customElements.get('mqle-pdp-main')) {
  class MqlePdpMain extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.variantInput = this.form?.querySelector('[name="id"]');
      this.quantityInput = this.form?.querySelector('[name="quantity"]');
      this.addButton = this.querySelector('[data-mqle-add]');
      this.addLabel = this.addButton?.querySelector('[data-mqle-add-label]');
      this.currentPrice = this.querySelector('[data-mqle-current-price]');
      this.priceMajor = this.querySelector('[data-mqle-price-major]');
      this.priceMinor = this.querySelector('[data-mqle-price-minor]');
      this.priceA11y = this.querySelector('[data-mqle-price-a11y]');
      this.comparePrice = this.querySelector('[data-mqle-compare-price]');
      this.discountChip = this.querySelector('[data-mqle-discount-chip]');
      this.shadeName = this.querySelector('[data-mqle-shade-name]');
      this.shadeDescription = this.querySelector('[data-mqle-shade-description]');
      this.galleryTrack = this.querySelector('[data-mqle-gallery-track]');
      this.variantButtons = [...this.querySelectorAll('[data-mqle-variant]')];
      this.thumbButtons = [...this.querySelectorAll('[data-mqle-thumb]')];
      this.colorMap = this.readColorMap();

      this.addEventListener('click', this.onClick.bind(this));
      this.galleryTrack?.addEventListener('scroll', this.onGalleryScroll.bind(this), { passive: true });
    }

    readColorMap() {
      const el = this.querySelector('[data-mqle-renk-harita]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    applyColor(variantId) {
      if (!this.colorMap) return;
      const active = this.colorMap[variantId];
      if (active === undefined) return;
      this.querySelectorAll('[data-mqle-renk]').forEach((el) => {
        const renk = el.getAttribute('data-mqle-renk');
        el.hidden = !!(active && renk && renk !== active);
      });
    }

    syncThumbMark(mediaId) {
      const target = mediaId
        ? this.querySelector(`.mqle-gallery__slide[data-media-id="${CSS.escape(String(mediaId))}"]`)
        : null;
      if (target && !target.hidden) {
        this.thumbButtons.forEach((thumb) =>
          thumb.setAttribute('aria-current', String(thumb.dataset.mediaId === target.dataset.mediaId))
        );
        return;
      }
      this.onGalleryScroll();
    }

    onClick(event) {
      const variantButton = event.target.closest('[data-mqle-variant]');
      if (variantButton && !variantButton.disabled) {
        this.selectVariant(variantButton);
        return;
      }

      const thumb = event.target.closest('[data-mqle-thumb]');
      if (thumb) {
        this.scrollToMedia(thumb.dataset.mediaId);
        return;
      }

      const quantityButton = event.target.closest('[data-mqle-quantity]');
      if (quantityButton && this.quantityInput) {
        const delta = Number(quantityButton.dataset.mqleQuantity || 0);
        const next = Math.max(1, Number(this.quantityInput.value || 1) + delta);
        this.quantityInput.value = next;
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    selectVariant(button) {
      this.variantButtons.forEach((item) => item.setAttribute('aria-checked', String(item === button)));
      if (this.variantInput) {
        this.variantInput.value = button.dataset.variantId;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (this.shadeName) this.shadeName.textContent = button.dataset.variantName || '';
      if (this.shadeDescription) this.shadeDescription.textContent = button.dataset.variantDescription || '';

      if (this.priceMajor) this.priceMajor.textContent = button.dataset.priceMajor || button.dataset.price || '';
      if (this.priceMinor) this.priceMinor.textContent = button.dataset.priceMinor || '';
      if (this.priceA11y) this.priceA11y.textContent = button.dataset.priceA11y || '';

      const compare = button.dataset.comparePrice || '';
      if (this.currentPrice) this.currentPrice.classList.toggle('mqle-price__current--sale', !!compare);
      if (this.comparePrice) {
        this.comparePrice.textContent = compare;
        this.comparePrice.hidden = !compare;
      }

      if (this.discountChip) this.discountChip.textContent = button.dataset.discountChip || '';

      const available = button.dataset.available === 'true';
      if (this.addButton) this.addButton.disabled = !available;
      if (this.addLabel) {
        this.addLabel.textContent = available
          ? this.addButton.dataset.availableLabel
          : this.addButton.dataset.soldoutLabel;
      }

      this.applyColor(button.dataset.variantId);
      if (button.dataset.mediaId) this.scrollToMedia(button.dataset.mediaId);
      this.syncThumbMark(button.dataset.mediaId);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', button.dataset.variantId);
      window.history.replaceState({}, '', url);
    }

    scrollToMedia(mediaId) {
      const slide = this.querySelector(`.mqle-gallery__slide[data-media-id="${CSS.escape(String(mediaId))}"]`);
      if (!slide || slide.hidden) return;
      slide.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }

    onGalleryScroll() {
      if (this.galleryFrame) return;
      this.galleryFrame = requestAnimationFrame(() => {
        this.galleryFrame = null;
        if (!this.galleryTrack) return;
        const center = this.galleryTrack.scrollLeft + this.galleryTrack.clientWidth / 2;
        let active = null;
        let distance = Infinity;
        this.querySelectorAll('.mqle-gallery__slide[data-media-id]').forEach((slide) => {
          if (slide.hidden) return;
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const nextDistance = Math.abs(center - slideCenter);
          if (nextDistance < distance) {
            distance = nextDistance;
            active = slide;
          }
        });
        if (!active) return;
        this.thumbButtons.forEach((thumb) =>
          thumb.setAttribute('aria-current', String(thumb.dataset.mediaId === active.dataset.mediaId))
        );
      });
    }
  }

  customElements.define('mqle-pdp-main', MqlePdpMain);
}
